import { Alert, Modal } from 'antd';
import { PreSalesHandoverType } from '../../../dto/model';
import { strings } from '../../../lang';

type PreSalesPvQualifiedDialogProps = {
  open: boolean;
  handoverType: PreSalesHandoverType;
  isForwarding: boolean;
  blockingError?: string;
  onConfirm: () => void;
  onDismiss: () => void;
};

export const PreSalesPvQualifiedDialog = ({
  open,
  handoverType,
  isForwarding,
  blockingError,
  onConfirm,
  onDismiss,
}: PreSalesPvQualifiedDialogProps) => {
  const isPvHandover = handoverType === 'hp_to_pv';

  return (
    <Modal
      className="bp-presales-handover-dialog"
      title={isPvHandover
        ? strings.preSalesQuestionnaire.pvOnlyQualifiedTitle
        : strings.preSalesQuestionnaire.pvQualifiedTitle}
      open={open}
      okText={isPvHandover
        ? strings.preSalesQuestionnaire.pvForwardButton
        : strings.preSalesQuestionnaire.combiForwardButton}
      cancelText={strings.preSalesQuestionnaire.pvDeclineButton}
      confirmLoading={isForwarding}
      okButtonProps={{ disabled: isForwarding || Boolean(blockingError) }}
      cancelButtonProps={{ disabled: isForwarding }}
      closable={!isForwarding}
      maskClosable={false}
      onOk={onConfirm}
      onCancel={onDismiss}
    >
      <Alert
        className="bp-presales-handover-dialog__next-step"
        type="info"
        showIcon
        message={isPvHandover
          ? strings.preSalesQuestionnaire.pvHandoverNextStep
          : strings.preSalesQuestionnaire.combiHandoverNextStep}
        description={isPvHandover
          ? strings.preSalesQuestionnaire.pvOnlyQualifiedDescription
          : strings.preSalesQuestionnaire.pvQualifiedDescription}
      />
      <p className="bp-presales-handover-dialog__decline-copy">
        {strings.preSalesQuestionnaire.pvQualifiedAbortDescription}
      </p>
      {blockingError && (
        <Alert
          type="error"
          showIcon
          message={strings.preSalesQuestionnaire.pvConfigurationError}
          description={blockingError}
        />
      )}
    </Modal>
  );
};
